/**
 * @generated SignedSource<<1c57ea6bdcc567c58de8e9317ddf985c>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { Fragment, ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type ShippingDetailsContainer_viewer$data = {
  readonly item?: {
    readonly lastTransaction: {
      readonly serviceId: string | null;
    } | null;
    readonly serviceId: string | null;
    readonly " $fragmentSpreads": FragmentRefs<"ShippingDetailsBuyerLocationForm_item" | "ShippingDetailsQuotesTable_item">;
  } | null;
  readonly regionalInfo: ReadonlyArray<{
    readonly countryCode: string | null;
    readonly zipCode: string | null;
  } | null> | null;
  readonly user?: {
    readonly addressBook: {
      readonly addressList: ReadonlyArray<{
        readonly country: string | null;
        readonly serviceId: string | null;
        readonly zipCode: string | null;
      } | null> | null;
      readonly personalAddress: {
        readonly country: string | null;
        readonly serviceId: string | null;
        readonly zipCode: string | null;
      } | null;
      readonly proAddress: {
        readonly country: string | null;
        readonly serviceId: string | null;
        readonly zipCode: string | null;
      } | null;
    } | null;
    readonly serviceId: string | null;
    readonly " $fragmentSpreads": FragmentRefs<"clientAbTestV2_useAbTestV2BuyerUser_user">;
  } | null;
  readonly " $fragmentSpreads": FragmentRefs<"ShippingDetailsBuyerLocationForm_viewer" | "ShippingDetailsQuotesTable_viewer">;
  readonly " $fragmentType": "ShippingDetailsContainer_viewer";
};
export type ShippingDetailsContainer_viewer$key = {
  readonly " $data"?: ShippingDetailsContainer_viewer$data;
  readonly " $fragmentSpreads": FragmentRefs<"ShippingDetailsContainer_viewer">;
};

const node: ReaderFragment = (function(){
var v0 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "serviceId",
  "storageKey": null
},
v1 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "zipCode",
  "storageKey": null
},
v2 = [
  (v0/*: any*/),
  {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "country",
    "storageKey": null
  },
  (v1/*: any*/)
];
return {
  "argumentDefinitions": [
    {
      "kind": "RootArgument",
      "name": "hasUserId"
    },
    {
      "kind": "RootArgument",
      "name": "itemId"
    },
    {
      "kind": "RootArgument",
      "name": "shouldFetchItem"
    },
    {
      "kind": "RootArgument",
      "name": "userId"
    }
  ],
  "kind": "Fragment",
  "metadata": null,
  "name": "ShippingDetailsContainer_viewer",
  "selections": [
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "ShippingDetailsQuotesTable_viewer"
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "ShippingDetailsBuyerLocationForm_viewer"
    },
    {
      "condition": "shouldFetchItem",
      "kind": "Condition",
      "passingValue": true,
      "selections": [
        {
          "alias": null,
          "args": [
            {
              "kind": "Variable",
              "name": "itemId",
              "variableName": "itemId"
            },
            {
              "kind": "Literal",
              "name": "pageType",
              "value": "SHIPPING_MODAL"
            }
          ],
          "concreteType": "Item",
          "kind": "LinkedField",
          "name": "item",
          "plural": false,
          "selections": [
            (v0/*: any*/),
            {
              "alias": null,
              "args": [
                {
                  "kind": "Variable",
                  "name": "buyerId",
                  "variableName": "userId"
                }
              ],
              "concreteType": "Transaction",
              "kind": "LinkedField",
              "name": "lastTransaction",
              "plural": false,
              "selections": [
                (v0/*: any*/)
              ],
              "storageKey": null
            },
            {
              "args": null,
              "kind": "FragmentSpread",
              "name": "ShippingDetailsQuotesTable_item"
            },
            {
              "args": null,
              "kind": "FragmentSpread",
              "name": "ShippingDetailsBuyerLocationForm_item"
            }
          ],
          "storageKey": null
        }
      ]
    },
    {
      "condition": "hasUserId",
      "kind": "Condition",
      "passingValue": true,
      "selections": [
        {
          "alias": null,
          "args": [
            {
              "kind": "Variable",
              "name": "userId",
              "variableName": "userId"
            }
          ],
          "concreteType": "User",
          "kind": "LinkedField",
          "name": "user",
          "plural": false,
          "selections": [
            (v0/*: any*/),
            {
              "alias": null,
              "args": null,
              "concreteType": "AddressBook",
              "kind": "LinkedField",
              "name": "addressBook",
              "plural": false,
              "selections": [
                {
                  "alias": null,
                  "args": null,
                  "concreteType": "Address",
                  "kind": "LinkedField",
                  "name": "addressList",
                  "plural": true,
                  "selections": (v2/*: any*/),
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "concreteType": "Address",
                  "kind": "LinkedField",
                  "name": "proAddress",
                  "plural": false,
                  "selections": (v2/*: any*/),
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "concreteType": "Address",
                  "kind": "LinkedField",
                  "name": "personalAddress",
                  "plural": false,
                  "selections": (v2/*: any*/),
                  "storageKey": null
                }
              ],
              "storageKey": null
            },
            {
              "args": null,
              "kind": "FragmentSpread",
              "name": "clientAbTestV2_useAbTestV2BuyerUser_user"
            }
          ],
          "storageKey": null
        }
      ]
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "RegionalInfo",
      "kind": "LinkedField",
      "name": "regionalInfo",
      "plural": true,
      "selections": [
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "countryCode",
          "storageKey": null
        },
        (v1/*: any*/)
      ],
      "storageKey": null
    }
  ],
  "type": "Viewer",
  "abstractKey": null
};
})();

(node as any).hash = "996d5c2d785692dd8c8a9dc8cea985fd";

export default node;
